module.exports = __webpack_public_path__ + "img/logo3.c216f8f1.png";